import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleFileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6693 6.66536V9.9987C14.6693 13.332 13.3359 14.6654 10.0026 14.6654H6.0026C2.66927 14.6654 1.33594 13.332 1.33594 9.9987V5.9987C1.33594 2.66536 2.66927 1.33203 6.0026 1.33203H9.33594",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6693 6.66536H12.0026C10.0026 6.66536 9.33594 5.9987 9.33594 3.9987V1.33203L14.6693 6.66536Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66406 8.66797H8.66406",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66406 11.332H7.33073",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSingleFileIcon;
